import { Control } from '@yleisradio/areena-types';
import { FunctionComponent, SVGProps } from 'react';
import Home from '../common/assets/icon-home.svg';
import User from '../common/assets/icon-user.svg';
import Favorite from '../common/assets/favorite.svg';
import Grid from '../common/assets/grid.svg';
import Headphones from '../common/assets/headphones.svg';
import Search from '../common/assets/search.svg';
import Settings from '../common/assets/settings.svg';
import Tv from '../common/assets/tv.svg';
import LiveStreaming from '../common/assets/live-streaming.svg';
import FavoriteActive from '../common/assets/favorite-active.svg';
import GridActive from '../common/assets/grid-active.svg';
import HeadphonesActive from '../common/assets/headphones-active.svg';
import SearchActive from '../common/assets/search-active.svg';
import SettingsActive from '../common/assets/settings-active.svg';
import TvActive from '../common/assets/tv-active.svg';
import LiveStreamingActive from '../common/assets/live-streaming-active.svg';

/*TODO 2.2025 Nina: icon-prefixed icon names are for old menu icons,
delete after api gives us new icons also for childrens menu */

function getAssetIcon(
  control: Control,
  active: boolean
): FunctionComponent<SVGProps<SVGAElement>> | undefined {
  if (control.icon && active) {
    switch (control.icon.id) {
      case 'profile':
        return User;
      case 'search':
      case 'icon-tab-browse':
        return SearchActive;
      case 'favorite':
      case 'icon-tab-my-program':
        return FavoriteActive;
      case 'settings':
      case 'icon-settings':
        return SettingsActive;
      case 'grid':
      case 'icon-grid':
        return GridActive;
      case 'tv':
        return TvActive;
      case 'headphones':
        return HeadphonesActive;
      case 'live-streaming':
      case 'icon-tab-tv':
        return LiveStreamingActive;
      default:
        return undefined;
    }
  }
  if (control.icon) {
    switch (control.icon.id) {
      case 'icon-profile':
      case 'profile':
        return User;
      case 'icon-tab-home':
        return Home;
      case 'icon-tab-browse':
      case 'search':
        return Search;
      case 'icon-tab-my-program':
      case 'favorite':
        return Favorite;
      case 'icon-settings':
      case 'settings':
        return Settings;
      case 'icon-grid':
      case 'grid':
        return Grid;
      case 'tv':
        return Tv;
      case 'headphones':
        return Headphones;
      case 'live-streaming':
      case 'icon-tab-tv':
        return LiveStreaming;
      default:
        return undefined;
    }
  }
  return undefined;
}

/* Lasten menu needs fallback icons for
before new lasten menu with podcasts is implemented */
export function getAssetIconWithFallback(
  control: Control,
  isActivePodcastMenuIcon: boolean
) {
  const primaryIcon = getAssetIcon(control, isActivePodcastMenuIcon);
  return primaryIcon || getAssetIcon(control, false);
}
